import {
  MQTT_CONFIG_REQUEST_FAILURE,
  MQTT_CONFIG_REQUEST_SUCCESS,
  SAVE_MQTT_CONFIG_REQUEST_SUCCESS
} from '../actions/actionTypes'

import union from 'lodash/union'
import { IMqttConfiguration } from '../../types/mqtt_configuration'

const initialState = {
  allIds: [],
  byIds: {}
}

const fn = function (state = initialState, action) {
  switch (action.type) {
    case MQTT_CONFIG_REQUEST_SUCCESS:
      return {
        ...state,
        allIds: union(state.allIds, [action.response.result]),
        byIds: Object.assign(
          {},
          state.byIds,
          action.response.entities.configurations
        )
      }

    case MQTT_CONFIG_REQUEST_FAILURE:
      return Object.assign({}, state, { errorMessage: action.error })

    case SAVE_MQTT_CONFIG_REQUEST_SUCCESS:
      let resultConfig: IMqttConfiguration = Object.values(
        action.response.entities.configurations
      )[0] as IMqttConfiguration
      let streamid = resultConfig.streamId
      if (streamid !== undefined) {
        let resultObject = {}
        resultObject[streamid] = resultConfig
        return {
          ...state,
          allIds: union(state.allIds, [resultConfig.streamId]),
          byIds: Object.assign({}, state.byIds, resultObject)
        }
      } else {
        return state
      }

    default:
      return state
  }
}
export default fn
